import { z } from "zod";
import { customersApiSchema } from "../services/customersService";
import { InvestmentSchema, productsApiSchema } from "../services/productsService";
import { paginatedResponse } from "../utils";
import { OfferSchema } from "./offer";
import { statusApiSchema } from "./status";

const BookingReasonSchema = z.object({
    id: z.string(),
    reason_name: z.string(),
    reason_name_eng: z.string(),
});

const BookingCustomerSchema = z.object({
    status: statusApiSchema.status,
    customer: customersApiSchema.customer,
});

const BookingResponseEntrySchema = z.object({
    id: z.string(),
    nr: z.string(),
    customers: z.array(BookingCustomerSchema),
    start: z.string(),
    end: z.string(),
    status: statusApiSchema.status,
    reason: BookingReasonSchema.nullable(),
    note: z.string(),
    creator: z.string(),
    products: z.array(productsApiSchema.product),
    offer: OfferSchema.nullable(),
});

const CreateBookingRequestSchema = z.object({
    customer_ids: z.array(z.string().uuid()),
    start: z.string().datetime(),
    end: z.string().datetime(),
    note: z.string(),
    products: z
        .array(
            z.object({
                product_id: z.string().uuid(),
                discount_percent: z.number().min(-100).max(100),
            }),
        )
        .optional(),
    offer_id: z.string().uuid().optional().nullable(),
    source_booking: z.string().uuid().optional().nullable(),
});

const PutUpdatebookingRequestSchema = z.object({
    customer_ids: z.array(z.string().uuid()),
    note: z.string(),
    products: z
        .array(
            z.object({
                product_id: z.string().uuid(),
                discount_percent: z.number().min(-100).max(100),
            }),
        )
        .optional(),
    offer_id: z.string().uuid().optional().nullable(),
});

const BookingCancellationReasonSchema = z.object({
    id: z.string(),
    reason_name: z.string(),
    reason_name_eng: z.string(),
});

const BookingPostponedResponseSchema = z.array(BookingResponseEntrySchema);

const CancelBookingRequestSchema = z.object({
    reason_id: z.string().uuid(),
    status_note: z.string().optional().nullable()
});

const CustomerBookingResponseEntrySchema = z.object({
    booking_id: z.string().uuid(),
    booking_nr: z.string(),
    investment: InvestmentSchema,
    gross_price: z.string(),
    product_type: z.string(),
    product_number: z.string().nullable(),
    start_date: z.string(),
    end_date: z.string(),
    creator: z.string(),
    status: statusApiSchema.status,
    booking_status: statusApiSchema.status,
});

export const GetBookingsResponseSchema = paginatedResponse(BookingResponseEntrySchema);
export const GetBookingStatusesResponseSchema = paginatedResponse(statusApiSchema.status);
export const GetBookingCancellationReasonsResponseSchema = paginatedResponse(
    BookingCancellationReasonSchema,
);
export const GetCustomerBookingsResponseSchema = paginatedResponse(
    CustomerBookingResponseEntrySchema,
);

export const bookingsApiSchema = {
    createBookingRequest: CreateBookingRequestSchema,
    putUpdateBookingRequest: PutUpdatebookingRequestSchema,
    cancelBookingRequest: CancelBookingRequestSchema,
    bookingResponseEntry: BookingResponseEntrySchema,
    bookingCustomer: BookingCustomerSchema,
    bookingReason: BookingReasonSchema,
    bookingCancellationReason: BookingCancellationReasonSchema,
    getBookingsResponse: GetBookingsResponseSchema,
    getBookingStatusesResponse: GetBookingStatusesResponseSchema,
    getBookingPostponedResponse: BookingPostponedResponseSchema,
    getBookingCancellationReasonsResponse: GetBookingCancellationReasonsResponseSchema,
    customerBookingResponseEntry: CustomerBookingResponseEntrySchema,
    getCustomerBookingsResponse: GetCustomerBookingsResponseSchema,
};
